export const WEIGHT_ROOT = '/health/weight/';
export const PUP_INFO_SUBPATH = 'pup';
export const UPLOAD_PHOTO_SUBPATH = 'photo';
export const EMAIL_SUBPATH = 'email';

export const VALID_WEIGHT_SUBPATHS = [
  PUP_INFO_SUBPATH,
  UPLOAD_PHOTO_SUBPATH,
  EMAIL_SUBPATH,
];
export const VALID_SCREENING_SUBPATHS = ['weight'];
